#import "../../../field/fragments/eav-fragment.graphql"

fragment CustomFieldEdgeFragment on CustomFieldsEdge {
    value {
        ...EntityAttributeValue
    }
    node {
        ...EntityAttribute
    }
}
